import TextToSpeechButton from './TextToSpeechButton';

export default TextToSpeechButton;
